import { withAuth } from 'hocs/auth/with-auth';
import { Home } from './home';

const WrapAuth = withAuth(Home);

export { WrapAuth as Home };
